import { ChevronRightIcon } from "@heroicons/react/24/outline";
import Badge from "./Badge";
import Button from "./buttons/Button";
import H1 from "./forms/H1";
import { useTranslation } from "react-i18next";
import { Company, JobAd } from "../lib/models";
import ArrowIcon from "./ArrowIcon";

const JobAdDetails: React.FC<{
  jobAd?: JobAd | null;
  company?: Company | null;
  showButton?: boolean;
  previewMode?: boolean;
  onClick?: (e: React.MouseEvent<HTMLButtonElement>) => void;
}> = ({ jobAd, company, showButton = false, onClick, previewMode = false }) => {
  const { t } = useTranslation(["ApplicationView", "HomeView"]);

  return (
    <div className="flex flex-col items-center justify-center max-w-4xl mx-auto text-center gap-y-4 py-8">
      <div className="flex gap-2">
        {jobAd?.city && <Badge text={jobAd.city} />}
        {jobAd?.employmentType && <Badge text={jobAd.employmentType} />}
        {jobAd?.workLocation && <Badge text={jobAd.workLocation} />}
      </div>
      <H1 text={jobAd?.title} />
      <div className="max-w-40">
        {showButton && onClick && !previewMode && (
          <Button
            variant="contained"
            text={t("ApplicationView:apply")}
            onClick={onClick}
            icon={<ArrowIcon />}
          />
        )}
      </div>
    </div>
  );
};

export default JobAdDetails;
